/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-accordion {
  display: block;
  max-width: 100%;
}
.ux-accordion__button {
  background: none;
  border: 0;
  line-height: 1.6;
  text-align: start;
  padding: 0;
}
.ux-accordion__title-container {
  align-items: center;
  border-bottom: 1px solid #e2e2e2;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding: 15px;
  transition-delay: 250ms;
}
@media only screen and (width >= 768px) {
  .ux-accordion__title-container {
    padding: 20px 30px;
  }
}
.ux-accordion__title-container > * {
  display: block;
  margin: 0;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ux-accordion__title-container ux-icon[name=chevron-down] {
  font-size: 13px;
  margin-left: 20px;
  transition: transform 250ms ease;
}
.ux-accordion__content-container {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out, padding 250ms ease;
}
@media only screen and (width >= 768px) {
  .ux-accordion__content-container {
    padding-left: 30px;
    padding-right: 30px;
  }
}
.ux-accordion--active .ux-accordion__content-container {
  padding: 20px 0 30px;
}
@media only screen and (width >= 768px) {
  .ux-accordion--active .ux-accordion__content-container {
    padding: 30px 30px 45px;
  }
}
.ux-accordion--active .ux-accordion__title-container ux-icon[name=chevron-down] {
  transform: rotate(180deg);
}
.ux-accordion--active .ux-accordion__content-container {
  border-bottom: 1px solid #e2e2e2;
}
.ux-accordion--full-title .ux-accordion__title-container > * {
  overflow: auto;
  white-space: normal;
}

.ux-accordion--grey-shadow .ux-accordion__title-container {
  align-items: flex-start;
  background-color: #eff0f4;
  border-bottom: 0;
  box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08);
  margin-bottom: 15px;
  padding: 15px 30px;
}
.ux-accordion--grey-shadow .ux-accordion__title-container > * {
  overflow: auto;
  white-space: normal;
}
.ux-accordion--grey-shadow .ux-accordion__content-container {
  border-bottom: 0;
}